module.exports = __webpack_public_path__ + "static/img/bannermachine.f7fe5e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/companyprofilepic/bannermachine.png
// module id = iIyq
// module chunks = 51